const ROUTES = {
  VALIDATE_OTP: "/validate-otp",
  HOME: "/home",
  PROFILE_DETAIL: "/profile-detail",
  PROFILE_VERIFICATION: "/profile-verification",
  INFRASTRUCTURE_DETAILS: "/infrastructure-details",
  STAFF_DETAILS: "/staff_details",
  PAYMENT_DETAILS: "/payment_details",
  FAQ: "/faq",
  APPOINMENTS: "/appointments",
  PROVIDER_PROFILE_DETAILS: "/provider-details",
  HELLO_ADMIN: "/hello-admin",
  UNATHORIZED: "/unauthorized",
  // ROLES: "/hello-admin/roles",
  APPOINMENT_MANAGEMENT: "/appointment-management",
  TESTS_PACKAGES: "/test_packages",
  TEST_PACKAGES_PROVIDERMAPPING: "/test_packages/provider-mapping",
  TEST_PACKAGES_TESTCREATION: "/test_packages/test-creation",
  TEST_PACKAGES_PACKAGECREATION: "/test_packages/package-creation",
  PROVIDER_ASSIST: "/provider-assist",
  NETWORK_INTELLIGENCE_DASHBOARD: "/intelligence/dashboard",
  NETWORK_INTELLIGENCE_USAGECOVERAGE: "/intelligence/usageCoverage",
  NETWORK_INTELLIGENCE_SETTLEMENTS: "/intelligence/clientcoverage",
  NETWORK_INTELLIGENCE_ADOPTION_ANALYSIS: "/intelligence/adoption-analysis",
  NETWORK_PAYOUT:"/payout/networkpayout",
  NETWORK_PAYABLES:"/payout/Payables",
  INSURER_BILLING:"/insurer/insurerbilling",
  INSURER_RECEIVABLES:"/insurer/Receivables",
  INSURER_DASHBOARD:"/insurer/insurerdashboard",
  INSURER_PENDING_RECEIVABLES:"/insurer/pendingreceivables",
  INSURER_INVOICE_GENERATION:"/insurer/invoicegeneration",
  ADVANCE_PAYMENT:"/payout/advancepayment",
  NETWORK_PAYOUT_DASH:"/payout/payoutdashboard",
  NETWORK_PAYOUT_OUTLINE:"/payout/PayoutOutLine"
};

export default ROUTES;
